module.exports = __webpack_public_path__ + "src/assets/animations/strawberry.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/strawberry.png
// module id = ./src/assets/animations/strawberry.png
// module chunks = 0